import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * 'clsx' is a utility for constructing classnames conditionally.
 * Its main use is for 'structuring' classnames in a way that is easy to read and write.
 *
 * 'twMerge' is a utility for merging Tailwind CSS classnames.
 * Its main use is for 'merging' classnames while preventing to generate conflicting classnames.
 */
export function classNames(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
